import { TAccessLevel } from 'src/components/access';

export const authorize = (
    accessLevel: TAccessLevel,
    ...levels: TAccessLevel[]
) => {
    return levels.includes(accessLevel);
};
